module.exports = __webpack_public_path__ + "img/Checked.f2327ae7.png";